/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { injectIntl, intlShape } from 'react-intl';
import { Panel, Table } from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import RichLabel from 'loracoms/RichLabel';
import CollapseToggle from 'loracoms/CollapseToggle';
import styles from './styles.scss';

const propTypes = {
  intl: intlShape.isRequired,
  status: PropTypes.string.isRequired,
  gatewayStatus: PropTypes.object.isRequired,
};

class Channels extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      status: props.status,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.gateway.channel');
  }

  componentWillReceiveProps({ gatewayStatus, status }) {
    if (!_.isEqual(gatewayStatus, this.props.gatewayStatus)) {
      this.initData(gatewayStatus);
    }
    if (status !== this.props.status) {
      this.setState({ status });
    }
  }

  initData({ channels = [] } = {}) {
    let list = [];
    _.forEach(channels, ({ channel, services }) => {
      const ser = _.map(services, s => ({ ...s, channel }));
      list = _.concat(list, ser);
    });
    this.setState({ list });
  }

  render() {
    const {
      list = [],
      expanded = true,
    } = this.state;
    const header = (
      <div styleName="header">
        {this.intlMsg.msg('header')}
        <CollapseToggle
          expanded={expanded}
          onChange={v => this.setState({ expanded: v })}
        />
      </div>
    );
    return (
      <Panel
        collapsible
        header={header}
        bsStyle="aisz-white"
      >
        <Table className="aisz-table-light" striped>
          <thead>
            <tr>
              <th>{this.intlMsg.msg('id')}</th>
              <th>{this.intlMsg.msg('service')}</th>
              <th>{this.intlMsg.msg('used')}</th>
              <th>{this.intlMsg.msg('free')}</th>
            </tr>
          </thead>
          <tbody>
            {_.map(list, (l, idx) => (
              <tr key={idx}>
                <td><RichLabel content={String(l.channel)} /></td>
                <td>{l.service}</td>
                <td>{l.used}</td>
                <td>{l.free}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Panel>
    );
  }
}

Channels.propTypes = propTypes;

export default injectIntl(CSSModules(Channels, styles, { allowMultiple: true }));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/GatewayStatus/Channels.jsx